import React, { useState, useEffect, useRef } from 'react';

export const COUNTRY_CODES = [
  { code: '+94', country: 'Sri Lanka', flag: '🇱🇰' },
  { code: '+1', country: 'United States', flag: '🇺🇸' },
  { code: '+44', country: 'United Kingdom', flag: '🇬🇧' },
  { code: '+61', country: 'Australia', flag: '🇦🇺' },
  { code: '+91', country: 'India', flag: '🇮🇳' },
  { code: '+971', country: 'United Arab Emirates', flag: '🇦🇪' },
  { code: '+65', country: 'Singapore', flag: '🇸🇬' },
  { code: '+81', country: 'Japan', flag: '🇯🇵' },
  { code: '+49', country: 'Germany', flag: '🇩🇪' },
  { code: '+33', country: 'France', flag: '🇫🇷' },
  { code: '+39', country: 'Italy', flag: '🇮🇹' },
  { code: '+86', country: 'China', flag: '🇨🇳' },
  { code: '+82', country: 'South Korea', flag: '🇰🇷' },
  { code: '+60', country: 'Malaysia', flag: '🇲🇾' },
  { code: '+64', country: 'New Zealand', flag: '🇳🇿' },
  { code: '+27', country: 'South Africa', flag: '🇿🇦' },
  { code: '+55', country: 'Brazil', flag: '🇧🇷' },
  { code: '+52', country: 'Mexico', flag: '🇲🇽' },
  { code: '+7', country: 'Russia', flag: '🇷🇺' },
  { code: '+31', country: 'Netherlands', flag: '🇳🇱' },
  { code: '+41', country: 'Switzerland', flag: '🇨🇭' },
  { code: '+46', country: 'Sweden', flag: '🇸🇪' },
  { code: '+34', country: 'Spain', flag: '🇪🇸' }
];

export const SearchableCountrySelect = ({ value, onChange, className = "" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filtered = COUNTRY_CODES.filter(c =>
    c.country.toLowerCase().includes(search.toLowerCase()) ||
    c.code.includes(search)
  );

  const selected = COUNTRY_CODES.find(c => c.code === value) || { code: value, flag: '🌐' };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center justify-between w-28 border border-brand-darkSage/20 rounded-lg px-3 py-3 bg-white/50 focus:ring-brand-gold outline-none ${className}`}
      >
        <span>{selected.flag} {selected.code}</span>
      </button>
      
      {isOpen && (
        <div className="absolute z-50 mt-1 w-64 bg-white border border-brand-darkSage/20 rounded-lg shadow-xl flex flex-col" style={{ maxHeight: '240px' }}>
          <div className="p-2 border-b border-brand-darkSage/10">
            <input
              type="text"
              placeholder="Search country or code..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full text-sm px-2 py-1.5 border border-brand-darkSage/20 rounded-md outline-none focus:border-brand-gold"
              autoFocus
            />
          </div>
          <div className="overflow-y-auto custom-scrollbar flex-1">
            {filtered.map(c => (
              <button
                key={c.code + c.country}
                type="button"
                onClick={() => {
                  onChange({ target: { name: 'countryCode', value: c.code }});
                  setIsOpen(false);
                  setSearch('');
                }}
                className="w-full text-left px-3 py-2 text-sm hover:bg-brand-sand transition-colors flex items-center justify-between"
              >
                <span>{c.flag} {c.country}</span>
                <span className="text-brand-lightText text-xs font-mono">{c.code}</span>
              </button>
            ))}
            {filtered.length === 0 && (
              <div className="px-3 py-4 text-center text-xs text-brand-lightText">No results found</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};